import {storage} from "utils";
import {login} from "./thunks";
import {UserModel} from "interfaces";
import {initialState} from "./initial-state";
import {createSlice, isAnyOf, PayloadAction} from "@reduxjs/toolkit";

export const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    forceLogin: function (
      state,
      action: PayloadAction<UserModel & {token: string}>
    ) {
      const data = action["payload"];
      const {token, ...user} = data;

      state["user"] = user;
      state["isLogged"] = true;

      storage["set"]("[user]", user);
      storage["set"]("[auth-token]", token);
    },
    logOut: function () {
      storage["delete"]("[user]");
      storage["delete"]("[auth-token]");

      setTimeout(() => {
        window["location"]["href"] = "/";
      }, 800);
    },
  },
  extraReducers: function (builder) {
    builder.addMatcher(isAnyOf(login.fulfilled), function (state, action) {
      const {data} = action["payload"];
      const {token, ...user} = data;

      state["user"] = user;
      state["isLogged"] = true;

      storage["set"]("[user]", user);
      storage["set"]("[auth-token]", token);
    });
  },
});
export default auth["reducer"];
export const {logOut, forceLogin} = auth["actions"];
